module.exports = __webpack_public_path__ + "static/media/se_page2to4.c25485ce.ogg";